module.exports = __webpack_public_path__ + "static/img/logohdpi.5e80878.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logohdpi.png
// module id = MyP6
// module chunks = 1